<template lang="html">
  <!-- <span> -->
  <v-menu
    open-on-hover
    nudge-right="30"
    nudge-down="30"
  >
    <template #activator="{ on }">
      <v-icon
        v-bind="$attrs"
        :class="classes"
        v-on="on"
      >
        {{ icon }}
      </v-icon>
    </template>
    <v-card>
      <v-card-text
        style="max-width:400px"
        v-html="helpText"
      />
    </v-card>
  </v-menu>
  <!-- </span> -->
</template>

<script>
export default {
  props: {
    helpText: String,
    icon: {
      type: String,
      default: 'help_outline'
    },
    iconClass: String
  },
  computed: {
    classes () {
      return `${this.iconClass || ''} cursor-help`
    }
  }
}
</script>

<style lang="css" scoped>
</style>
